<div class="settings-row-label">
    <slot />
</div>

<style>
    .settings-row-label {
        font-size: 1.2em;
        /*margin-bottom: 10px;*/
        flex: 0.1 0 200px;
        padding: 7px 0;
    }
</style>
